import type { FC, ReactNode } from 'react'
import type { Project } from '@/types'

import { ProjectCard } from '@/components/landing/project-card'

interface PortfolioSectionProps {
    projects: Array<Project>
}

export const PortfolioSection: FC<PortfolioSectionProps> = ({ projects }): ReactNode => {
    return (
        <section id='portfolio' aria-labelledby='portfolio-title' className='w-full bg-background px-4 md:px-8'>
            <div className='mx-auto w-full max-w-site py-12 md:py-16 lg:py-20'>
                <div className='mb-12 flex max-w-[43rem] flex-col items-start text-left text-balance'>
                    <p className='mb-2.5 text-base leading-[1.3] font-semibold'>
                        Showcase Your Skills
                    </p>

                    <h2 id='portfolio-title' className='font-heading text-heading-2 font-medium'>
                        Explore Our Portfolio of Projects
                    </h2>

                    <p className='mt-2 text-base leading-[1.3] text-muted-foreground'>
                        Discover a collection of our finest work, illustrating innovative designs and successful development strategies.
                    </p>
                </div>

                {projects.length > 0
                    ? (
                        <ul className='grid grid-cols-1 gap-x-8 gap-y-16 md:grid-cols-2 md:pb-24'>
                            {projects.map(project => (
                                <li key={project.id} className='md:even:translate-y-25'>
                                    <ProjectCard project={project} />
                                </li>
                            ))}
                        </ul>
                    )
                    : (
                        <p className='rounded-card border border-dashed border-border px-6 py-12 text-center text-muted-foreground'>
                            New projects are on their way. Check back soon.
                        </p>
                    )}
            </div>
        </section>
    )
}
